export default {
  title: 'We cannot find this page',
  text: 'Please make sure that the URL address is correct',
  button: 'Go back',
};
